import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const i18n = new VueI18n({
    locale: 'en',
    fallbackLocale: 'en',
    messages: {
        'en': require('./en.json'),
        'fr_BE': require('./fr_BE.json'),
        'nl_BE': require('./nl_BE.json')
    },
    silentTranslationWarn: true
})

if (module.hot) {
    module.hot.accept(['./en.json', './fr_BE.json', './nl_BE.json'], () => {
        i18n.setLocaleMessage('en', require('./en.json'))
        i18n.setLocaleMessage('fr_BE', require('./fr_BE.json'))
        i18n.setLocaleMessage('nl_BE', require('./nl_BE.json'))
    })
}

export default i18n


// WEBPACK FOOTER //
// ./src/i18n/index.js